import * as React from 'react';

import IconButton from '../icon-button';
import Icon from '../icon';
import Typography from '../typography';
import Badge from '../badge';
import {
	Root,
	IconLayout,
	ContentLayout,
} from './styled';


type ListGroupHeaderProps = {
	toggle: () => void;
	groupID: string | number;
	count: number;
	isCollapsed: boolean;
}

const ListGroupHeader: React.SFC<ListGroupHeaderProps> = (props) => {
	const {
		toggle,
		isCollapsed,
		groupID,
		count,
		children,
	} = props;

	return (
		<Root onClick={toggle}>
			<IconButton>
				<IconLayout isCollapsed={isCollapsed}>
					<Icon type='expand-more' width={24} height={24} color='primary' />
				</IconLayout>
			</IconButton>
			<Typography.Text fontWeight={700} marginRight={'10px'}>{groupID}</Typography.Text>
			<Badge>{count}</Badge>
			<ContentLayout>{children}</ContentLayout>
		</Root>
	);
}

ListGroupHeader.displayName = 'ListGroupHeader';
ListGroupHeader.defaultProps = {};

export default ListGroupHeader;
